import { render } from "./orderSpec.vue?vue&type=template&id=317670e6&scoped=true"
import script from "./orderSpec.vue?vue&type=script&lang=js"
export * from "./orderSpec.vue?vue&type=script&lang=js"

import "./orderSpec.vue?vue&type=style&index=0&id=317670e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-317670e6"]])

export default __exports__